import {CommentDiscussionIcon, DiscussionClosedIcon} from '@primer/octicons-react'
import {ActionList, type ActionListItemProps, Truncate} from '@primer/react'

import type {AutocompleteDiscussion} from '../../utils/copilot-chat-types'

interface DiscussionSuggestionProps extends ActionListItemProps {
  discussion: AutocompleteDiscussion
}

export function DiscussionSuggestion({discussion, ...props}: DiscussionSuggestionProps) {
  return (
    <ActionList.Item {...props}>
      <ActionList.LeadingVisual>
        {discussion.state === 'open' && <CommentDiscussionIcon className="fgColor-open" />}
        {discussion.state === 'closed' && <DiscussionClosedIcon className="fgColor-muted" />}
      </ActionList.LeadingVisual>
      <Truncate title={discussion.title} maxWidth={350}>
        {discussion.title}
      </Truncate>
      <ActionList.Description>#{discussion.number}</ActionList.Description>
    </ActionList.Item>
  )
}

try{ DiscussionSuggestion.displayName ||= 'DiscussionSuggestion' } catch {}